import { render, staticRenderFns } from "./temhead4.vue?vue&type=template&id=2d954d86&scoped=true"
import script from "./temhead4.vue?vue&type=script&lang=js"
export * from "./temhead4.vue?vue&type=script&lang=js"
import style0 from "./temhead4.vue?vue&type=style&index=0&id=2d954d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d954d86",
  null
  
)

export default component.exports